import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";
import { ListElement, ProfilePicture } from "../../components";
import { Badge } from "../badge/Badge";

export type BusinessListElementBusinessType = {
  name: string;
  logoUrl: string | null;
  type: "retailer" | "supplier";
  DeliveryAddress: {
    postalCode: string;
  };
};
export function BusinessListElement({
  text,
  business,
  onClick,
}: {
  business: BusinessListElementBusinessType;
  onClick: () => void;
  text?: string;
}): ReactElement {
  return (
    <ListElement onClick={onClick} promptText={text || "Switch"}>
      <ProfilePicture name={business.name} logoUrl={business.logoUrl} />
      <div className={`space-y-2`}>
        <span>{business.name}</span>
        <div className={twMerge("flex items-center gap-1 text-secondary")}>
          <Badge>{business.type === "retailer" ? "Venue" : "Supplier"}</Badge>
          <Badge>{business.DeliveryAddress.postalCode}</Badge>
        </div>
      </div>
    </ListElement>
  );
}
